import Slider, { Range } from 'rc-slider';

import './style.scss';

export const CustomRange = ({
  min,
  max,
  sliderValue,
  onSliderChange,
  step = 1,
  sliderValuesPrefix = '',
  sliderValuesSufix = '',
  ariaLabel = 'Range slider',
  ariaLabelMin = 'Minimum value',
  ariaLabelMax = 'Maximum value',
}) => (
  <div className="slider__wrap" role="group" aria-label={ariaLabel}>
    <Range
      min={min}
      max={max}
      step={step}
      value={sliderValue}
      onChange={onSliderChange}
      ariaLabelForHandle={[ariaLabelMin, ariaLabelMax]}
    />
    <div className="slider__values" aria-live="polite">
      <span>{`${sliderValuesPrefix} ${sliderValue[0]} ${sliderValuesSufix}`}</span>
      <span>{`${sliderValuesPrefix} ${sliderValue[1]} ${sliderValuesSufix}`}</span>
    </div>
  </div>
);

export const CustomSlider = ({
  min,
  max,
  sliderValue,
  onSliderChange,
  step = 1,
  sliderValuesPrefix = '',
  ariaLabel = 'Slider',
}) => {
  return (
    <div className="slider__wrap" role="group" aria-label={ariaLabel}>
      <Slider
        min={min}
        max={max}
        step={step}
        value={sliderValue}
        onChange={onSliderChange}
        ariaLabelForHandle={ariaLabel}
      />
      <div className="slider__values" aria-live="polite">
        <span>{`${sliderValuesPrefix} ${sliderValue}`}</span>
      </div>
    </div>
  );
};

export default CustomSlider;
